<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de usuarios</h1>
    <div class="results" v-if="users">
      <div class="results__element" v-for="(user, index) in users" :key="index">
        <div class="results__info">
          <h2 class="results__title" v-text="user.first_name + ' ' + user.last_name"></h2>
          <p class="results__text" v-text="'Correo: ' + user.email"></p>
          <p class="results__text" v-text="'Rol: ' + user.role_name"></p>
        </div>
        <div class="results__actions">
          <button @click.prevent="$parent.$emit('view', user.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">Ver Usuario</button>
          <button @click.prevent="$parent.$emit('edit', user.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">Editar Usuario</button>
          <button @click.prevent="deleteUser(user.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">Borrar Usuario</button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    }
  },
  mixins: [
    httpService
  ],
  components: {confirmation},
  data: function () {
    return {
      userId: null,
      users: null,
      confirm: false
    }
  },
  created: function () {
    this.getUsers()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    filters: function () {
      this.getUsers()
    },
    '$store.state.elementChanged': function () {
      this.getUsers()
    }
  },
  methods: {
    getUsers: function () {
      let httpRequest = {
        params: '?' + this.filters,
        module: 'users'
      }
      this.get(httpRequest)
        .then(
          users => {
            this.users = users.data
          }
        ).catch(
          () => {
            this.users = null
          }
        )
    },
    deleteUser: function (id) {
      this.confirm = true
      this.userId = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        params: '',
        module: 'users'
      }
      this.delete(this.userId, httpRequest)
        .then(
          response => {
            this.getUsers()
            this.$store.commit('notificate', {
              title: 'USUARIO BORRADO',
              text: 'El usuario ha sido borrado correctamente',
              type: 'success'
            })
          }
        ).catch (
          error => {
            this.$store.commit('notificate', {
              title: 'USUARIO NO BORRADO',
              text: 'No se pudo borrar el usuario seleccionado, por favor intente más tarde',
              type: 'warn'
            })
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/users/list.vue